import { useMutation, useQueryClient } from '@tanstack/react-query'

import { campaignKeys } from 'features/campaigns/api/queryKeys'

import { updateProjectAction } from '../api'
import { projectKeys } from '../api/queryKeys'

const useUpdateProjectActionMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateProjectAction,
    onSuccess: (_, { accountId, projectId }) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.projects(accountId),
      })
      queryClient.invalidateQueries({
        queryKey: projectKeys.projectConfig({ accountId, projectId }),
      })
      queryClient.invalidateQueries({
        queryKey: campaignKeys.projects(accountId),
      })
    },
  })
}

export default useUpdateProjectActionMutation
